import { uiText, useUiLanguage } from '../utils/uiTranslation';
import React from 'react';

const CalendarConnectionPrompt = ({ onClose, onConnectCalendar, onScheduleManually, candidateName }) => {
  useUiLanguage();
  return (
    <div className="applicant-popup" style={{ display: 'flex' }}>
      <div className="applicant-popup-content" style={{ maxWidth: '500px', width: '90%' }}>
        {/* Header */}
        <div className="modal-header">
          <h2>{uiText("Schedule Interview")}</h2>
          <div className="close" onClick={onClose}>&times;</div>
        </div>

        {/* Main Content */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          {/* Candidate Info */}
          <div style={{
            backgroundColor: '#f8f9fa',
            padding: '20px',
            borderRadius: '8px',
            marginBottom: '25px',
            border: '1px solid #dee2e6'
          }}>
            <i className="fa-solid fa-user-tie" style={{ fontSize: '32px', color: '#568ded', marginBottom: '10px' }}></i>
            <h3 style={{ margin: '0 0 5px 0', color: "var(--app-neutral-ink, #333)", fontSize: '18px' }}>{uiText("Ready to interview ")}{candidateName || uiText("this candidate")}?
            </h3>
            <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>{uiText("Connect your calendar for seamless scheduling")}</p>
          </div>

          {/* Benefits Section */}
          <div style={{
            backgroundColor: 'linear-gradient(135deg, #568ded 0%, #4a7bd1 100%)',
            background: 'linear-gradient(135deg, #568ded 0%, #4a7bd1 100%)',
            color: 'white',
            padding: '25px',
            borderRadius: '10px',
            marginBottom: '25px'
          }}>
            <h3 style={{ margin: '0 0 20px 0', fontSize: '20px' }}>
              <i className="fa-solid fa-star" style={{ marginRight: '8px' }}></i>{uiText("Unlock Professional Scheduling")}</h3>
            
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', textAlign: 'left' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <i className="fa-solid fa-video" style={{ fontSize: '20px', marginRight: '10px', color: '#FFD700' }}></i>
                <span style={{ fontSize: '14px' }}>{uiText("Automatic Google Meet links")}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <i className="fa-solid fa-envelope" style={{ fontSize: '20px', marginRight: '10px', color: '#FFD700' }}></i>
                <span style={{ fontSize: '14px' }}>{uiText("Professional email invites")}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <i className="fa-solid fa-clock" style={{ fontSize: '20px', marginRight: '10px', color: '#FFD700' }}></i>
                <span style={{ fontSize: '14px' }}>{uiText("Smart time suggestions")}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <i className="fa-solid fa-shield-check" style={{ fontSize: '20px', marginRight: '10px', color: '#FFD700' }}></i>
                <span style={{ fontSize: '14px' }}>{uiText("Conflict detection")}</span>
              </div>
            </div>
          </div>

          {/* Setup Time */}
          <div style={{
            backgroundColor: '#e8f4fd',
            padding: '15px',
            borderRadius: '6px',
            marginBottom: '25px',
            border: '1px solid #b8daff'
          }}>
            <p style={{ margin: 0, color: '#004085', fontSize: '14px' }}>
              <i className="fa-solid fa-stopwatch" style={{ marginRight: '8px' }}></i>
              <strong>{uiText("Quick setup:")}</strong>{uiText(" Connect your calendar (Google or Outlook) in under 30 seconds")}</p>
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {/* Primary Action - Connect Calendar */}
          <button
            onClick={onConnectCalendar}
            style={{ '--light-control-fill': '#568ded',
              padding: '15px 25px',
              backgroundColor: '#568ded',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '16px',
              fontFamily: 'Montserrat',
              fontWeight: "var(--app-weight-strong, bold)",
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#4a7bd1';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#568ded';
              e.target.style.transform = 'translateY(0)';
            }}
            data-light-control={"filled"}>
            <i className="fab fa-google" style={{ marginRight: '10px', fontSize: '18px' }}></i>{uiText("Connect Calendar & Schedule")}</button>

          {/* Secondary Actions */}
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              onClick={onScheduleManually}
              style={{
                flex: 1,
                padding: '12px 20px',
                backgroundColor: 'transparent',
                color: '#568ded',
                border: '2px solid #568ded',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontFamily: 'Montserrat',
                fontWeight: "var(--app-weight-strong, bold)"
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#568ded';
                e.target.style.color = 'var(--app-text, white)';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = '#568ded';
              }}
              data-light-control={"quiet"}>
              <i className="fa-solid fa-edit" style={{ marginRight: '8px' }}></i>{uiText("Schedule Manually")}</button>

            <button
              onClick={onClose}
              style={{
                flex: 1,
                padding: '12px 20px',
                backgroundColor: 'var(--app-surface, #6c757d)',
                color: 'var(--app-text, white)',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontFamily: 'Montserrat',
                fontWeight: "var(--app-weight-strong, bold)"
              }}
              data-light-control={"quiet"}>
              <i className="fa-solid fa-times" style={{ marginRight: '8px' }}></i>{uiText("Maybe Later")}</button>
          </div>
        </div>

        {/* Footer Note */}
        <div style={{
          marginTop: '20px',
          padding: '12px',
          backgroundColor: '#f8f9fa',
          borderRadius: '6px',
          textAlign: 'center'
        }}>
          <p style={{ margin: 0, fontSize: '12px', color: '#666' }}>
            <i className="fa-solid fa-lock" style={{ marginRight: '5px' }}></i>{uiText("Your calendar data is encrypted and secure. You can disconnect anytime.")}</p>
        </div>
      </div>
    </div>
  );
};

export default CalendarConnectionPrompt; 